export const normalizeSyncDate = (value) => {
  if (!value) {
    return null
  }

  if (typeof value.seconds === 'number') {
    return { seconds: value.seconds }
  }

  if (typeof value.toDate === 'function') {
    const date = value.toDate()
    return { seconds: Math.floor(date.getTime() / 1000) }
  }

  if (value instanceof Date) {
    return { seconds: Math.floor(value.getTime() / 1000) }
  }

  if (typeof value === 'string' || typeof value === 'number') {
    const date = new Date(value)
    if (!Number.isNaN(date.getTime())) {
      return { seconds: Math.floor(date.getTime() / 1000) }
    }
  }

  return null
}

export const normalizeSyncDatesDoc = (doc) => {
  if (!doc) {
    return {}
  }

  return Object.entries(doc).reduce((acc, [key, value]) => {
    const normalized = normalizeSyncDate(value)
    if (normalized) {
      acc[key] = normalized
    }
    return acc
  }, {})
}

export const parseLastSyncFromResponse = (data) => {
  if (data === null) {
    return normalizeSyncDate(new Date())
  }

  if (!data?.lastSync) {
    return null
  }

  try {
    return normalizeSyncDate(JSON.parse(data.lastSync))
  } catch {
    return normalizeSyncDate(data.lastSync)
  }
}

const isGenericInternalText = (value) =>
  typeof value === 'string' && value.trim().toLowerCase() === 'internal'

const pickUserFacingText = (...candidates) => {
  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim() && !isGenericInternalText(candidate)) {
      return candidate.trim()
    }
  }

  return null
}

export const extractCallableErrorMessage = (error, fallback = 'Помилка виконання функції') => {
  if (!error) {
    return fallback
  }

  const code = typeof error.code === 'string' ? error.code.replace('functions/', '') : ''
  const details = error.details

  const fromDetailsObject =
    details && typeof details === 'object' && typeof details.message === 'string'
      ? details.message
      : null

  const explicit = pickUserFacingText(
    typeof details === 'string' ? details : null,
    fromDetailsObject,
    error.message
  )

  if (explicit) {
    return explicit
  }

  if (code === 'failed-precondition') {
    return 'Умови для генерації фіду не виконані (немає підходящих товарів або даних).'
  }

  if (code === 'deadline-exceeded') {
    return 'Час очікування вичерпано. Спробуйте ще раз або задеплойте функцію з більшим timeout.'
  }

  if (code === 'internal') {
    return fallback
  }

  return fallback
}

export const getCallableErrorMessage = (error) => {
  if (!error) {
    return 'Помилка синхронізації'
  }

  const code = typeof error.code === 'string' ? error.code.replace('functions/', '') : ''

  if (code === 'not-found') {
    return 'Функцію syncOutletProducts не знайдено. Задеплойте: firebase deploy --only functions:syncOutletProducts'
  }

  if (code === 'unauthenticated') {
    return 'Потрібна авторизація'
  }

  if (code === 'permission-denied') {
    return 'Немає доступу'
  }

  return extractCallableErrorMessage(error, code ? `Помилка (${code})` : 'Помилка синхронізації')
}
